const logEvent = (event: string, data?: object): void => {
  if (process.env.REACT_APP_LOG_ANALYTICS) {
    console.log(`[ TRACKING ]: ${event}`, data);
  }
};

export default logEvent;
